document.addEventListener('DOMContentLoaded', function () {

  /* Mobile nav */
  var burger = document.querySelector('.hamburger');
  var nav    = document.querySelector('.header-nav');
  if (burger && nav) {
    burger.addEventListener('click', function () { nav.classList.toggle('nav-open'); });
    document.addEventListener('click', function (e) {
      if (!nav.contains(e.target) && !burger.contains(e.target)) nav.classList.remove('nav-open');
    });
  }

  /* FAQ accordion */
  document.querySelectorAll('.faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item   = this.closest('.faq-item');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function (i) { i.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });

});
